//import 'core-js/stable';
import 'regenerator-runtime/runtime';
//import 'bootstrap/dist/js/bootstrap.bundle';
import 'bootstrap/js/dist/carousel';
import Cookies from 'js-cookie';
import DOMPurify from 'dompurify';
import isMobile from './responsive.js';

var responsive = isMobile();

/*
 * Get siblings of a element
 */
let getSiblings = (e) => {
  let siblings = [];

  if (!e.parentNode) {
    return siblings;
  }

  let sibling = e.parentNode.firstChild;

  while (sibling) {
    if (sibling.nodeType === 1 && sibling !== e) {
      siblings.push(sibling);
    }
    sibling = sibling.nextSibling;
  }
  return siblings;
}

/*
 * Clear node inner
 */
let clearNode = (node) => {
  while (node.firstChild) {
    node.removeChild(node.firstChild);
  }
}


const siteSearch = document.querySelector('.site-search');
const searchField = document.querySelector('#woocommerce-product-search-field');
let searchResultContainer = document.querySelector("#searchResult");
 
document.addEventListener('DOMContentLoaded', () => {

  /*
   * Search bar events
   */
  
  document.querySelectorAll('.open-search a').forEach((button) => {
    button.addEventListener('click', (e) => {
      e.preventDefault();
      siteSearch.classList.remove('d-none');
      document.body.classList.add('noscroll');
    });
  });

  document
    .querySelector('.site-search-close')
    .addEventListener('click', (e) => {
      e.preventDefault();
      siteSearch.classList.add('d-none');
      searchField.value = '';
      clearNode(searchResultContainer);
      siteSearch.querySelector('.myloader').classList.add('d-none');
      document.body.classList.remove('noscroll');
    });
  });

  searchField.addEventListener('keyup', function(e){
  
    clearNode(searchResultContainer);
    
    let keyword = DOMPurify.sanitize(this.value, {USE_PROFILES: {html: false, mathMl: false, svg: false}});
    const loader = siteSearch.querySelector('.myloader');
    loader.classList.remove('d-none');

    if(keyword.length > 2) {
      
      fetch(ajaxurl[0], {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Cache-Control': 'no-cache',
        },
        body: new URLSearchParams({
            action: 'woo_custom_search',
            s: keyword,
        })

      }).then(
        (response) => {
          
          if(response.ok){
            response.json().then((data) => { 
              loader.classList.add('d-none');
              clearNode(searchResultContainer);
              
              for(let result of data){

                const range = document.createRange();
                range.selectNode(searchResultContainer);
                const child = range.createContextualFragment(result);
                searchResultContainer.appendChild(child);               
                
              }

              
            });

          }

        }
      );
    }

  })

let headerHeight = () => {
  const banner = document.querySelector('.banner');
  const header = document.querySelector('.header');

  if(null !== banner){
    document.querySelector('.content-wrapper').style.paddingTop = header.clientHeight + 'px';
  }

}

document.addEventListener('DOMContentLoaded', () => {
  headerHeight();
});


/*
 * Window resize events
 */
window.addEventListener('resize', (e) => {
  responsive = isMobile();

  headerHeight();
});

/*
 * Check and register closed banners in a cookie
 */
const banner = document.querySelector('.banner');
const navbar = document.querySelector('.navbar');

if(null !== banner){

  const hash = banner.getAttribute('data-cookie');

  if (1 === parseInt(Cookies.get('banner_' + hash))) {
    banner.remove();
  } else {
    banner.querySelector('#closeBanner').addEventListener('click', (e) => {

      banner.classList.add('closed');
      banner.remove();

      Cookies.set('banner_' + hash, 1, { expires: 1 });

      document.querySelector('.content-wrapper').style.paddingTop = navbar.clientHeight + 'px';
    });
  }
}


/*
 * Shop page filters
 */
let topFilters = document.querySelector('.wc-top-filters');
if(null !== topFilters) {

  topFilters.querySelector('.filters-toggler').addEventListener('click', function(e){

    if(responsive){
      topFilters.classList.toggle('open');
      document.body.classList.toggle('noscroll');
    }

  });
  
  topFilters.querySelectorAll('h4').forEach((filter) => {
    filter.addEventListener('click', function(e) {
      let widget = this.parentNode;
      widget.classList.toggle('open');

      let otherWidgets = getSiblings(widget);

      for(let otherWidget of otherWidgets){
        otherWidget.classList.remove('open');
      }
    });
  });

}


/*
 * Top link
 */
var box = document.getElementById("top-link");
window.addEventListener('scroll', function() {
  if (document.documentElement.scrollTop > 500) {
    box.style.opacity = "1";
    box.style.transition = "opacity 1s";
  }
  else {
    box.style.opacity = "0";
  }
});


document.addEventListener('click', function (event) {
	if (!event.target.closest('#top-link')) return;
	event.preventDefault();
    window.scroll({
        top: 0,
        behavior: 'smooth' 
    });
}, false);


let scrollpos = window.scrollY;
const header = document.querySelector("#header");
const header_height = header.offsetHeight;

const add_class_on_scroll = () => header.classList.add("minimize")
const remove_class_on_scroll = () => header.classList.remove("minimize")

window.addEventListener('scroll', function() { 
  scrollpos = window.scrollY;

  if (scrollpos >= header_height) { 
    add_class_on_scroll();
  }
  else { 
    remove_class_on_scroll();
  }
});

/*
 * Lang switcher
 */
/*
const langSwitcher = document.querySelector('#langswitcher');

if(null !== langSwitcher) {
  const pllParent = langSwitcher.querySelector('.pll-parent-menu-item');

  pllParent.querySelector(':scope > a')
    .addEventListener('click', (e) => {
      e.preventDefault();
      langSwitcher.classList.toggle('open');
    });
}
*/
